function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 44.88,
  y1: 3.98,
  x2: 14.97,
  y2: 55.79,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#56c9e9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#3e5aa8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#b3519e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#ee203f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#fbed26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#76c043"
})));

var SvgDavinciResolve = function SvgDavinciResolve(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59.83 59.82",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M30.79,58.89h-1.71c-.08-.03-.16-.04-.24-.04-.92-.04-1.82-.12-2.72-.24-1.68-.22-3.34-.59-4.95-1.1-2.77-.89-5.35-2.16-7.73-3.81-2.22-1.54-4.18-3.35-5.88-5.45-2.01-2.45-3.58-5.16-4.69-8.14-1-2.64-1.59-5.38-1.77-8.2,0-.15-.03-.3-.08-.46v-2.98c.05-.13.07-.27.08-.41.04-.68.11-1.35.2-2.02.44-3.22,1.39-6.28,2.87-9.18,1.02-2,2.25-3.86,3.7-5.57,1.44-1.7,3.05-3.22,4.84-4.55,2.91-2.16,6.12-3.73,9.62-4.68,1.7-.46,3.44-.77,5.19-.91.31-.03.64,0,.95-.08h2.93c.22.07.46.03.68.05,1.16.1,2.32.25,3.46.47,3.61.71,6.96,2.06,10.05,4.06,2.4,1.55,4.53,3.41,6.38,5.58,1.49,1.74,2.75,3.64,3.78,5.68,1.22,2.42,2.09,4.95,2.59,7.62.26,1.41.46,2.83.46,4.27,0,.1.02.2.03.29v1.71c-.03.11-.03.22-.04.34,0,.28,0,.55-.02.83-.13,1.76-.41,3.49-.84,5.21-.84,3.22-2.18,6.2-4.05,8.95-1.39,2.05-3.01,3.89-4.87,5.53-1.85,1.63-3.88,3-6.08,4.11-2.54,1.28-5.2,2.16-8,2.65-1.07.19-2.16.31-3.25.38-.29.03-.59.03-.89.09h0Z",
    style: {
      fill: "#383938"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "path271",
    "data-name": "path27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.79,58.82h-1.71c-.08-.03-.16-.04-.24-.04-.92-.04-1.82-.12-2.72-.24-1.68-.22-3.34-.59-4.95-1.1-2.77-.89-5.35-2.16-7.73-3.81-2.22-1.54-4.18-3.35-5.88-5.45-2.01-2.45-3.58-5.16-4.69-8.14-1-2.64-1.59-5.38-1.77-8.2,0-.15-.03-.3-.08-.46v-2.98c.05-.13.07-.27.08-.41.04-.68.11-1.35.2-2.02.44-3.22,1.39-6.28,2.87-9.18,1.02-2,2.25-3.86,3.7-5.57,1.44-1.7,3.05-3.22,4.84-4.55,2.91-2.16,6.12-3.73,9.62-4.68,1.7-.46,3.44-.77,5.19-.91.31-.03.64,0,.95-.08h2.93c.22.07.46.03.68.05,1.16.1,2.32.25,3.46.47,3.61.71,6.96,2.06,10.05,4.06,2.4,1.55,4.53,3.41,6.38,5.58,1.49,1.74,2.75,3.64,3.78,5.68,1.22,2.42,2.09,4.95,2.59,7.62.26,1.41.46,2.83.46,4.27,0,.1.02.2.03.29v1.71c-.03.11-.03.22-.04.34,0,.28,0,.55-.02.83-.13,1.76-.41,3.49-.84,5.21-.84,3.22-2.18,6.2-4.05,8.95-1.39,2.05-3.01,3.89-4.87,5.53-1.85,1.63-3.88,3-6.08,4.11-2.54,1.28-5.2,2.16-8,2.65-1.07.19-2.16.31-3.25.38-.29.03-.59.03-.89.09h0Z",
    style: {
      fill: "#383938"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.38,1c.22.07.46.03.68.05,1.16.1,2.32.25,3.46.47,3.61.71,6.96,2.06,10.05,4.06,2.4,1.55,4.53,3.41,6.38,5.58,1.49,1.74,2.75,3.64,3.78,5.68,1.22,2.42,2.09,4.95,2.59,7.62.26,1.41.46,2.83.46,4.27,0,.1.02.2.03.29v1.71c-.03.11-.03.22-.04.34,0,.28,0,.55-.02.83-.13,1.76-.41,3.49-.84,5.21-.84,3.22-2.18,6.2-4.05,8.95-1.39,2.05-3.01,3.89-4.87,5.53-1.85,1.63-3.88,3-6.08,4.11-2.54,1.28-5.2,2.16-8,2.65-1.07.19-2.16.31-3.25.38-.29.03-.59.03-.89.09h0s-1.71,0-1.71,0c-.08-.03-.16-.04-.24-.04-.92-.04-1.82-.12-2.72-.24-1.68-.22-3.34-.59-4.95-1.1-2.77-.89-5.35-2.16-7.73-3.81-2.22-1.54-4.18-3.35-5.88-5.45-2.01-2.45-3.58-5.16-4.69-8.14-1-2.64-1.59-5.38-1.77-8.2,0-.15-.03-.3-.08-.46v-2.98c.05-.13.07-.27.08-.41.04-.68.11-1.35.2-2.02.44-3.22,1.39-6.28,2.87-9.18,1.02-2,2.25-3.86,3.7-5.57,1.44-1.7,3.05-3.22,4.84-4.55,2.91-2.16,6.12-3.73,9.62-4.68,1.7-.46,3.44-.77,5.19-.91.31-.03.64,0,.95-.08h2.93M31.51,0h-.13s-2.93,0-2.93,0h-.13l-.12.03c-.1.02-.24.03-.4.03-.13,0-.27,0-.4.02-1.81.15-3.62.47-5.36.95-3.6.99-6.95,2.62-9.95,4.85-1.83,1.36-3.52,2.94-5,4.7-1.49,1.76-2.78,3.7-3.83,5.76-1.52,2.99-2.52,6.19-2.97,9.5-.11.8-.17,1.46-.2,2.1,0,.07-.01.1-.01.1l-.07.17v3.33l.05.15c.02.06.03.11.03.14v.06c.19,2.9.81,5.76,1.84,8.49,1.14,3.05,2.77,5.88,4.86,8.42,1.76,2.15,3.81,4.05,6.09,5.63,2.46,1.71,5.15,3.03,8,3.94,1.67.53,3.4.92,5.13,1.14.86.12,1.78.2,2.81.25h0s0,0,0,0l.1.04h2l.1-.02c.12-.02.26-.03.42-.04.12,0,.23-.01.35-.03,1.14-.07,2.26-.2,3.33-.39,2.87-.5,5.65-1.42,8.27-2.74,2.26-1.14,4.38-2.57,6.29-4.25,1.9-1.67,3.6-3.59,5.03-5.72,1.91-2.82,3.32-5.94,4.19-9.26.44-1.73.73-3.54.87-5.38.02-.3.02-.59.02-.88v-.05s0-.06,0-.09l.03-.13v-.1s0-1.71,0-1.71v-.08c0-.05-.01-.11-.02-.17v-.06c-.01-1.3-.16-2.67-.49-4.44-.5-2.71-1.4-5.36-2.68-7.88-1.06-2.1-2.38-4.08-3.92-5.88-1.92-2.25-4.14-4.2-6.6-5.77-3.18-2.05-6.68-3.47-10.4-4.2-1.09-.21-2.26-.37-3.57-.49-.1,0-.22-.01-.33-.01h0s-.05,0-.08,0c-.03,0-.06,0-.09,0l-.14-.04h0Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "M22.39,17.98c-.02.53.07,1.11.23,1.69.3,1.11.79,2.12,1.38,3.07,1.33,2.18,3,4.04,4.82,5.77.15.14.33.26.52.35.19.1.38.1.58.01.19-.08.36-.21.5-.36.63-.65,1.25-1.3,1.85-1.98.84-.96,1.64-1.94,2.36-3,.66-.96,1.25-1.96,1.68-3.05.43-1.08.64-2.2.5-3.38-.24-1.94-1.03-3.58-2.45-4.87-1.67-1.52-3.62-2.13-5.82-1.79-3.57.55-6.16,3.84-6.14,7.53h0Z",
    style: {
      fill: "#3a9bd6",
      isolation: "isolate",
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "M40.86,44.43c-.45.01-.95-.04-1.46-.15-1.49-.33-2.76-1.01-3.73-2.21-.59-.73-1.09-1.53-1.52-2.36-.5-.99-.93-2.01-1.29-3.05-.45-1.26-.83-2.54-1.12-3.84-.16-.73.02-1.18.82-1.43,1.02-.32,2.05-.6,3.1-.84,1.74-.38,3.49-.62,5.27-.56.5.02,1.01.07,1.51.16,1.44.25,2.67.92,3.67,1.97,1.71,1.79,2.39,3.93,1.97,6.37-.61,3.49-3.7,5.97-7.21,5.94Z",
    style: {
      fill: "#ef3a49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "M18.37,44.43c.45.01.95-.04,1.46-.15,1.49-.33,2.76-1.01,3.73-2.21.59-.73,1.09-1.53,1.52-2.36.5-.99.93-2.01,1.29-3.05.45-1.26.83-2.54,1.12-3.84.16-.73-.02-1.18-.82-1.43-1.02-.32-2.05-.6-3.1-.84-1.74-.38-3.49-.62-5.27-.56-.5.02-1.01.07-1.51.16-1.44.25-2.67.92-3.67,1.97-1.71,1.79-2.39,3.93-1.97,6.37.61,3.49,3.7,5.97,7.21,5.94Z",
    style: {
      fill: "#f7f07f"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDavinciResolve, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "davinci-resolve.svg";
export { ForwardRef as ReactComponent };